import { useContext } from 'react';
import { TourContext } from '../components/TourProvider';
import { TourContextValue } from '../types/TourTypes';

/**
 * Hook para acessar o contexto do Tour
 * Retorna null se usado fora do TourProvider
 */
export const useTour = (): TourContextValue | null => {
  const context = useContext(TourContext);
  return context;
};
